// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Wu2d","rootCenter":"LoadMoreObserver_rootCenter__1RL24","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__HLf3L"};